module.exports = __webpack_public_path__ + "d34a010be83e882c7387c525feb67534.fbx";